import React from "react";

export function SealStamp({ lines = ["SEJAK", "1962"], className = "" }) {
  return (
    <div className={`seal-stamp ${className}`} aria-hidden="true">
      <div className="seal-stamp__inner">
        {lines.map((l) => (
          <span key={l}>{l}</span>
        ))}
      </div>
    </div>
  );
}

export function BowlArt({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 520 440"
      fill="none"
      role="img"
      aria-label="Ilustrasi semangkuk bakmi dengan sumpit"
    >
      <g className="steam" stroke="var(--ink)" strokeWidth="5" strokeLinecap="round" opacity="0.55">
        <path className="steam-line" style={{ animationDelay: "0s" }} d="M200 118c-10-16 10-26 0-44" />
        <path className="steam-line" style={{ animationDelay: "0.7s" }} d="M262 112c-10-16 10-26 0-44" />
        <path className="steam-line" style={{ animationDelay: "1.4s" }} d="M324 118c-10-16 10-26 0-44" />
      </g>
      <g stroke="var(--ink)" strokeWidth="6" strokeLinecap="round">
        <path d="M118 196c30-26 62-40 96-40" opacity="0.9" />
        <path d="M150 178c24-20 52-30 84-30" opacity="0.55" />
        <path d="M186 162c20-14 44-20 72-20" opacity="0.35" />
      </g>
      <g stroke="var(--ink)" strokeWidth="7" strokeLinecap="round">
        <line x1="330" y1="60" x2="438" y2="216" />
        <line x1="360" y1="48" x2="462" y2="208" />
      </g>
      <ellipse cx="258" cy="222" rx="176" ry="34" fill="var(--paper-deep)" stroke="var(--ink)" strokeWidth="7" />
      <g stroke="var(--ink)" strokeWidth="4" strokeLinecap="round" opacity="0.85">
        <path d="M140 214c26 10 52-8 78 2s52-8 78 2 52-8 78 2" />
        <path d="M152 226c24 9 48-7 72 2s48-7 72 2 48-7 72 2" />
      </g>
      <circle cx="200" cy="212" r="16" fill="var(--seal)" stroke="var(--ink)" strokeWidth="5" />
      <circle cx="318" cy="216" r="12" fill="var(--seal)" stroke="var(--ink)" strokeWidth="5" />
      <path
        d="M84 228c0 90 78 158 174 158s174-68 174-158l-20 4c-6 74-74 128-154 128S110 306 104 232l-20-4z"
        fill="var(--ink)"
      />
      <path d="M104 232c6 74 74 128 154 128" stroke="var(--paper)" strokeWidth="3" opacity="0.25" fill="none" />
      <ellipse cx="258" cy="398" rx="86" ry="12" fill="var(--ink)" />
      <g stroke="var(--paper)" strokeWidth="3" opacity="0.4" strokeLinecap="round">
        <line x1="130" y1="290" x2="150" y2="300" />
        <line x1="126" y1="312" x2="148" y2="320" />
      </g>
    </svg>
  );
}

export function GangArt({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 480 320"
      fill="none"
      role="img"
      aria-label="Ilustrasi lorong Gang Kelinci"
    >
      <g stroke="var(--paper)" strokeWidth="4" strokeLinecap="round" opacity="0.9">
        <path d="M20 20 L190 110" />
        <path d="M20 300 L190 210" />
        <path d="M460 20 L290 110" />
        <path d="M460 300 L290 210" />
      </g>
      <g stroke="var(--paper)" strokeWidth="2" opacity="0.4" strokeLinecap="round">
        <path d="M20 100 L188 150" />
        <path d="M20 180 L188 185" />
        <path d="M460 100 L292 150" />
        <path d="M460 180 L292 185" />
        <path d="M190 210 L190 110" opacity="0.7" />
        <path d="M290 210 L290 110" opacity="0.7" />
      </g>
      <g stroke="var(--paper)" strokeWidth="2" opacity="0.35" strokeLinecap="round">
        <path d="M120 268 L192 218" />
        <path d="M180 282 L214 224" />
        <path d="M360 268 L288 218" />
        <path d="M300 282 L266 224" />
      </g>
      <rect x="196" y="118" width="88" height="96" fill="var(--seal)" stroke="var(--paper)" strokeWidth="4" />
      <g fill="var(--paper)" fontFamily="IBM Plex Mono, monospace" fontSize="15" letterSpacing="2" textAnchor="middle">
        <text x="240" y="152">BAKMI</text>
        <text x="240" y="176">ABOEN</text>
        <text x="240" y="200">NO.16</text>
      </g>
      <circle cx="240" cy="58" r="18" stroke="var(--seal)" strokeWidth="4" />
      <line x1="240" y1="20" x2="240" y2="40" stroke="var(--paper)" strokeWidth="3" opacity="0.7" />
      <line x1="222" y1="58" x2="258" y2="58" stroke="var(--seal)" strokeWidth="3" />
    </svg>
  );
}

export function NoodleDivider({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 600 24"
      fill="none"
      aria-hidden="true"
      preserveAspectRatio="none"
    >
      <path
        d="M0 12c20-10 40-10 60 0s40 10 60 0 40-10 60 0 40 10 60 0 40-10 60 0 40 10 60 0 40-10 60 0 40 10 60 0 40-10 60 0 40 10 60 0"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SteamBowlIcon({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <g className="steam" stroke="currentColor" strokeWidth="3" strokeLinecap="round" opacity="0.6">
        <path className="steam-line" d="M24 22c-4-6 4-9 0-16" />
        <path className="steam-line" style={{ animationDelay: "0.6s" }} d="M40 22c-4-6 4-9 0-16" />
      </g>
      <path d="M10 30h44c0 14-10 24-22 24S10 44 10 30z" stroke="currentColor" strokeWidth="3.5" />
      <ellipse cx="32" cy="30" rx="22" ry="5" stroke="currentColor" strokeWidth="3.5" />
    </svg>
  );
}
